export const getSharedIconBoxStyle = ({ palette }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '6px 8px',
  background: 'transparent',
  border: 'none',
  pointerEvents: 'auto',
  '&:hover': {
    background: palette.neutralLighter,
  },
});
